/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import UIColorBrandBox from '../UI/ColorBrandBox';
import ColorExample from '../examples/Color';
import BackgroundColorExample from '../examples/BackgroundColor';
import IconColorExample from '../examples/IconColor';
import BackgroundPartialColorExample from '../examples/BackgroundPartialColor';
const ColorExampleSource = require('!!raw-loader!../examples/Color');
const BackgroundColorExampleSource = require('!!raw-loader!../examples/BackgroundColor');
const IconColorExampleSourse = require('!!raw-loader!../examples/IconColor');
const BackgroundPartialColorExampleSource = require('!!raw-loader!../examples/BackgroundPartialColor');
export default class ColorsPage extends React.Component {
    render() {
        return (<div>
                <div>
                    <Helmet title="Colors"/>
                    <h3>Colors</h3>
                    <div className="d-flex flex-wrap">
                        <UIColorBrandBox colorUsage="Brand Color Light" colorProps="$brand-color-light" colorName="Cyber Grape" colorHex="#65457d"/>
                        <UIColorBrandBox colorUsage="Brand Color Dark" colorProps="$brand-color-dark" colorName="Dark Purple" colorHex="#321c3d"/>
                        <UIColorBrandBox colorUsage="Brand Color Orange" colorProps="$brand-color-orange<br />$vivid-gamboge" colorName="Vivid Gamboge" colorHex="#f90"/>
                        <UIColorBrandBox colorUsage="Primary color" colorProps="$primary<br />$jungle-green" colorName="Jungle Green" colorHex="#18b48e"/>
                        <UIColorBrandBox colorUsage="Bg, Inverse Text" colorProps="$white" colorName="White" colorHex="#fff" whiteText={false}/>
                        <UIColorBrandBox colorUsage="Bg Context" colorProps="$catskill-white" colorName="Catskill White" colorHex="#f4f8f9" whiteText={false}/>
                        <UIColorBrandBox colorUsage="Links, Text" colorProps="$link-color" colorName="Cerulean Blue" colorHex="#284ba6"/>
                        <UIColorBrandBox colorUsage="Button Alternative" colorProps="$alternative<br />$blue-violet" colorName="Blue Violet" colorHex="#655eb9"/>
                        <UIColorBrandBox colorUsage="Bg Stars" colorProps="$athens-gray" colorName="Athens Gray" colorHex="#f5f6f8" whiteText={false}/>
                        <UIColorBrandBox colorUsage="Title" colorProps="$title<br />$dark-gray" colorName="Athens Gray" colorHex="#364650"/>
                        <UIColorBrandBox colorUsage="Text" colorProps="$body-color" colorName="Limed Spruce Light" colorHex="#45545d"/>
                        <UIColorBrandBox colorUsage="Secondary Text" colorProps="$secondary" colorName="Gray Chateau" colorHex="#99a0a6"/>
                        <UIColorBrandBox colorUsage="Discount Text, Error" colorProps="$danger" colorName="French Rose" colorHex="#f45978"/>
                        <UIColorBrandBox colorUsage="Rating, Warning" colorProps="$jaffa<br />$warning" colorName="Jaffa" colorHex="#f48853"/>
                    </div>
                    <p className="m-7">
                        Convey meaning through color with a handful of emphasis utility classes. These may also be
                        applied to links and will darken on hover just like our default link styles.
                    </p>
                    <div className="docs-example">
                        <ColorExample />
                    </div>
                    <pre>
                        <PrismCode className="language-jsx">{ColorExampleSource}</PrismCode>
                    </pre>
                </div>
                <div>
                    <Helmet title="Colors"/>
                    <h3>Background Colors</h3>
                    <p>
                        Similar to the contextual text color classes, easily set the background of an element to any
                        contextual class. Anchor components will darken on hover, just like the text classes. Background
                        utilities do not set color, so in some cases you’ll want to use .text-* utilities.
                    </p>
                    <div className="docs-example">
                        <BackgroundColorExample />
                    </div>
                    <pre>
                        <PrismCode className="language-jsx">{BackgroundColorExampleSource}</PrismCode>
                    </pre>
                </div>
                <div>
                    <h3>Icon Colors</h3>
                    <p>You can use all colors of the Theme and some custom</p>
                    <div className="docs-example">
                        <IconColorExample />
                    </div>
                    <pre>
                        <PrismCode className="language-jsx">{IconColorExampleSourse}</PrismCode>
                    </pre>
                </div>
                <div>
                    <Helmet title="Colors"/>
                    <h3>Background Partial Colors</h3>
                    <p>Can be used as partial background to connect it with next container with same background.</p>
                    <div className="docs-example">
                        <BackgroundPartialColorExample />
                    </div>
                    <pre>
                        <PrismCode className="language-jsx">{BackgroundPartialColorExampleSource}</PrismCode>
                    </pre>
                </div>
            </div>);
    }
}
